export default __webpack_public_path__ + "static/media/p18.33fa459d.jpeg";